import "./src/styles/global.css";
import "./node_modules/preline/dist/preline.js";

export const onClientEntry = () => {
	if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
		return;
	}

	navigator.serviceWorker.getRegistrations().then((registrations) => {
		registrations.forEach((registration) => {
			registration.unregister();
		});
	});

	if ("caches" in window) {
		caches.keys().then((keys) => {
			keys
				.filter((key) =>
					/gatsby-plugin-offline|workbox|offline-plugin/i.test(key)
				)
				.forEach((key) => caches.delete(key));
		});
	}
};
